import styled from 'styled-components';
import { motion, type Variants, type Transition } from 'framer-motion';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const Tag = styled(motion.div)`
  background-color: ${colorsV2.white100};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid ${colorsV2.neutral20};
  box-shadow: 0px 12px 24px 0px #30427814, 0px 3px 6px 0px #3042780f;
  position: absolute;
`;

export const Tag1 = styled(Tag)`
  z-index: 1;
`;

export const Tag2 = styled(Tag)`
  z-index: 2;
`;

export const Tag3 = styled(Tag)`
  z-index: 3;

  .star-ratings {
    display: flex !important;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .star-container {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }
`;

const tagTransition: Transition = {
  duration: 0.3,
  ease: 'easeOut',
};

export const tagWrapperVariants: Variants = {
  hidden: {
    transition: {
      staggerChildren: 0.075,
    },
  },
  visible: {
    transition: {
      staggerChildren: 0.075,
    },
  },
};
export const tag1Variants: Variants = {
  hidden: {
    left: 73,
    bottom: 25,
    x: '-50%',
    rotateZ: -95.71,
    transition: tagTransition,
  },
  visible: {
    left: 41,
    bottom: 54,
    x: '-50%',
    rotateZ: -31.35,
    transition: tagTransition,
  },
};

export const tag2Variants: Variants = {
  hidden: {
    left: 107,
    bottom: 24,
    x: '-50%',
    rotateZ: -64.91,
    transition: tagTransition,
  },
  visible: {
    left: 95,
    bottom: 35,
    x: '-50%',
    rotateZ: -51.92,
    transition: tagTransition,
  },
};

export const tag3Variants: Variants = {
  hidden: {
    left: 90,
    bottom: 15,
    x: '-50%',
    rotateZ: -80.7,
    transition: tagTransition,
  },
  visible: {
    left: 54,
    bottom: 32,
    x: '-50%',
    rotateZ: -41.71,
    transition: tagTransition,
  },
};
